import { ConfigSection } from '@components-fabric';
import { spaceFunctionsSection } from './space-functions.screens';
import { buildingParametersSection } from './building-parameters.screen';
import { structureComponentsSection } from './structure-components.screen';

/**
 * Configuration Object: presetsSection
 * 
 * This object contains the configuration for the presets section.
 * It includes nested sections for structure components, space functions, and building parameters.
 * 
 * @property {string} id - The identifier for the presets section.
 * @property {Array} sections - An array of nested section configurations.
 */
export const presetsSection: ConfigSection = {
  id: 'presets',
  sections: [
    // leave this commented for possible future implementation
    // structureComponentsSection,
    spaceFunctionsSection,
    buildingParametersSection,
  ],
};
